import PageLayout from 'pages/Quizzes/PageLayout';
import PageProvider from 'pages/Quizzes/PageProvider';

const QuizzesPage = () => (
    <PageProvider>
        <PageLayout />
    </PageProvider>
);

export default QuizzesPage;
